//import theme from 'styled-theming'

export const theme = {
  signatureBgColor: "#ffd194",
  signaturelightBgColor: "#fff6e9",
  signatureColor: "#d1913c",
  disableBgColor: "#c2c4c7",
  disablelightBgColor: "#f3f3f3",
  disableColor: "#8c8c8c",
  lightBgColor: "#ffe5c1",
  keywordColor: "#ffffff",
  keywordBgColor: "#08887d",
  selectKeywordBgColor: "#00bfaf",
  whiteColor: "#ffffff",
  blackColor: "#2d2d2d",
  starYellow: "#ffe92a",
  redColor: "#f44336",
  blueColor: "#3ca9ff",
  grayColor: "#545252ab",
  headerHeight: "7vh",
  footerHeight: "12vh",
  footerBgColor: "#f1f1f180",
  footerColor: "#9a9a9a66",
  menuBackgroundColor: "#82c5d230",
  mediumScreenWidth: "768px",
  smallScreenWidth: "425px",
  chatBoxBgColor: "#ffeed4",
  myChatBoxBgColor: "#19bbc72b",
};

// const themeBlue = {
//   signatureBgColor: "#212d45",
//   signatureColor: "#f1f1f1",
//   disableBgColor: "#c2c4c7",
//   disableColor: "#8c8c8c",
// };

// const themeGreen = {
//   signatureBgColor: "#DBD5A4",
//   signatureColor: "#649173",
//   disableBgColor: "#c2c4c7",
//   disableColor: "#8c8c8c",
// };
